
<template>
  <div class="updaterStatusBadges">
    <span
      v-for="(badge, index) in badges"
      :key="index"
      class="badge updaterBadge"
      :class="badge.colorClass"
    >
      {{ badge.text }}
    </span>
    <span v-if="badges.length === 0" class="badge updaterBadge badge-muted">
      {{ $t('receiptMatcher.noUpdaterStatus') }}
    </span>
  </div>
</template>

<script>
import { buildUpdaterStatusBadges } from '@/utils/sheetRowFunctions'

export default {
  name: 'UpdaterStatusBadges',
  props: {
    updaterStatus: {
      type: String,
      default: null,
    },
  },
  computed: {
    badges() {
      return buildUpdaterStatusBadges(this.updaterStatus)
    },
  },
}
</script>

<style scoped>
.updaterStatusBadges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}
.updaterBadge {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  line-height: 1;
}
.badge-red {
  background-color: var(--color-danger-10);
  color: var(--color-danger);
  border: 1px solid var(--color-danger-20);
}
.badge-yellow {
  background-color: var(--color-warning-10);
  color: var(--color-warning);
  border: 1px solid var(--color-warning-20);
}
.badge-green {
  background-color: var(--color-success-10);
  color: var(--color-success);
  border: 1px solid var(--color-success-20);
}
.badge-muted {
  background-color: transparent;
  color: #888;
  border: 1px dashed #555;
}
</style>